module.exports = __webpack_public_path__ + "img/dynamic-1.c0ea074d.png";